const channel_name = 'oppo';
const channel_type = '3';
exports = module.exports = {
  channel_type,
  channel_name
};